// Meme pack shared with the Sanitizer. Analyses store the file name
// (e.g. 'good3.png') in `memeURL`; the Sanitizer resolves it to its own asset.
// Play events store the full URL in `imageUrl`.
export const MEME_URLS: Record<string, string> = {
  'good.png': 'https://sanitize.page/assets/good-Dx3wxWNV.png',
  'good1.png': 'https://sanitize.page/assets/good1-C4SRhXN7.png',
  'good2.png': 'https://sanitize.page/assets/good2-BHIl0zN4.png',
  'good3.png': 'https://sanitize.page/assets/good3-3Kt4OXLU.png',
  'good4.png': 'https://sanitize.page/assets/good4-DKz_GQOG.png',
  'good5.png': 'https://sanitize.page/assets/good5-DqQsxEGf.png',
  'good6.png': 'https://sanitize.page/assets/good6-Zauf3_pO.png',
  'bad.png': 'https://sanitize.page/assets/bad-DG1QeDDV.png',
  'bad1.png': 'https://sanitize.page/assets/bad1-Bek4DHIG.png',
  'bad2.png': 'https://sanitize.page/assets/bad2-jspPhqLw.png',
  'bad3.png': 'https://sanitize.page/assets/bad3-DYITOaWl.png',
  'bad4.png': 'https://sanitize.page/assets/bad4-ByCBk6ur.png',
  'bad5.png': 'https://sanitize.page/assets/bad5-MI2Yq4OB.png',
  'bad6.png': 'https://sanitize.page/assets/bad6-utMEG-VC.png',
};

export const GOOD_MEMES = [
  'good.png',
  'good1.png',
  'good2.png',
  'good3.png',
  'good4.png',
  'good5.png',
  'good6.png',
];

export const BAD_MEMES = [
  'bad.png',
  'bad1.png',
  'bad2.png',
  'bad3.png',
  'bad4.png',
  'bad5.png',
  'bad6.png',
];

// Preload all meme images into browser memory cache at module load time.
// Holding HTMLImageElement references prevents eviction from memory cache,
// so subsequent <img src="..."> renders are instant with no network requests.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _preloadedMemes: HTMLImageElement[] = Object.values(MEME_URLS).map(
  (url) => {
    const img = new Image();
    img.src = url;
    return img;
  },
);
